exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-wrapper__main-content-wrapper__2Iddh{position:absolute;left:0;right:0;top:0;z-index:11}.ui-wrapper__info-overlay-wrapper__QocKc{position:absolute;top:0;left:0;right:0;bottom:0;z-index:8}.ui-wrapper__info-overlay-wrapper__QocKc.ui-wrapper__active__17oB9{z-index:12}.ui-wrapper__info-overlay__1Oz0c,.ui-wrapper__main-content__6hk6v{max-width:none;max-height:none;position:static;transition:.2s,opacity .2s;transition-timing-function:ease}.ui-wrapper__main-content-inner__npQUs{position:absolute;left:0;right:0;top:0;min-height:75px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;background:linear-gradient(0deg,transparent,rgba(0,0,0,.6)) no-repeat;background-size:100% 75px}.ui-wrapper__main-content-inner__npQUs.ui-wrapper__at-full-screen__25ahx .ui-wrapper__actions__1wkwo{margin-left:100px}.ui-wrapper__actions__1wkwo{z-index:100;margin-top:12px;margin-right:12px;margin-left:36px;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;-ms-flex-direction:column;flex-direction:column;transition:opacity .2s,visibility .2s}@media (max-width:300px){.ui-wrapper__actions__1wkwo{display:none}}", ""]);

// exports
exports.locals = {
	"main-content-wrapper": "ui-wrapper__main-content-wrapper__2Iddh",
	"mainContentWrapper": "ui-wrapper__main-content-wrapper__2Iddh",
	"info-overlay-wrapper": "ui-wrapper__info-overlay-wrapper__QocKc",
	"infoOverlayWrapper": "ui-wrapper__info-overlay-wrapper__QocKc",
	"active": "ui-wrapper__active__17oB9",
	"info-overlay": "ui-wrapper__info-overlay__1Oz0c",
	"infoOverlay": "ui-wrapper__info-overlay__1Oz0c",
	"main-content": "ui-wrapper__main-content__6hk6v",
	"mainContent": "ui-wrapper__main-content__6hk6v",
	"main-content-inner": "ui-wrapper__main-content-inner__npQUs",
	"mainContentInner": "ui-wrapper__main-content-inner__npQUs",
	"at-full-screen": "ui-wrapper__at-full-screen__25ahx",
	"atFullScreen": "ui-wrapper__at-full-screen__25ahx",
	"actions": "ui-wrapper__actions__1wkwo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/new-player/components/ui-wrapper.styl
// module id = 1643
// module chunks = 1 2 3